import { RadioButtons } from "@narmi/design_system";

const UserRoleRadio = ({
  create_user_eligible_roles,
}: {
  create_user_eligible_roles: { _id: string; narmi_name: string }[];
}) => {
  const options: { [key: string]: string } = {};
  create_user_eligible_roles.forEach((role) => {
    options[role.narmi_name] = role._id;
  });
  return (
    <div className="padding--top--m">
      <RadioButtons options={options} name="sisense_role_id" />
    </div>
  );
};

export default UserRoleRadio;
